/*    
<summary>
   This typescript file contains special datatype that enables for a variale to be set of predefined enums.
   Developer: Aashish Singh, Created Date: 14-June-2024 
</summary>
*/
enum FotaStatusEnum{
    None=0,
    Pending=1,
    Initiated=2,
    InProgress=3,
    Success=4,
    Aborted=5,
    Failed=6
}

export default FotaStatusEnum;